
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { List, Settings, User } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import AuthModal from '@/components/auth/AuthModal';
import UserDropdown from './UserDropdown';

interface NavbarActionsProps {
  onOpenSettings: () => void;
  onOpenTaskList: () => void;
}

const NavbarActions = ({ onOpenSettings, onOpenTaskList }: NavbarActionsProps) => {
  const { session } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState<'signin' | 'signup'>('signin');

  const handleSignIn = () => {
    setAuthMode('signin');
    setShowAuthModal(true);
  };

  return (
    <>
      {/* Task List Button */}
      <Button 
        onClick={onOpenTaskList}
        variant="ghost" 
        size="icon"
        className="bg-black/30 backdrop-blur-sm rounded-full border border-white/30 hover:bg-black/40 h-10 w-10"
        aria-label="Open Tasks"
      >
        <List className="h-5 w-5 text-white" />
      </Button>
      
      {/* Settings Button */}
      <Button 
        onClick={onOpenSettings}
        variant="ghost" 
        size="icon"
        className="bg-black/30 backdrop-blur-sm rounded-full border border-white/30 hover:bg-black/40 h-10 w-10"
        aria-label="Open Settings"
      >
        <Settings className="h-5 w-5 text-white" />
      </Button>

      {/* User Authentication */}
      {session ? (
        <UserDropdown />
      ) : (
        <Button 
          onClick={handleSignIn}
          variant="ghost" 
          size="icon"
          className="bg-black/30 backdrop-blur-sm rounded-full border border-white/30 hover:bg-black/40 h-10 w-10"
          aria-label="Sign In"
        >
          <User className="h-5 w-5 text-white" />
        </Button>
      )}

      <AuthModal 
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        initialMode={authMode}
      />
    </>
  );
};

export default NavbarActions;
